import { render, staticRenderFns } from "./otaProfile.vue?vue&type=template&id=d9e36a46"
import script from "./otaProfile.vue?vue&type=script&lang=js"
export * from "./otaProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports